import { createCustomEnum } from "../customEnum";

const StraddleAccountStatusTypes = createCustomEnum({
	Created: {
		value: 0,
		name: "created",
		displayName: "Created",
	},
	Onboarding: {
		value: 1,
		name: "onboarding",
		displayName: "Onboarding",
	},
	Active: {
		value: 2,
		name: "active",
		displayName: "Active",
	},
	Rejected: {
		value: 3,
		name: "rejected",
		displayName: "Rejected",
	},
	Inactive: {
		value: 4,
		name: "inactive",
		displayName: "Inactive",
	},
});

export default StraddleAccountStatusTypes;
